import { useNavigate } from "react-router-dom";
import { FadingCarousel } from "./FadingCarousel";
import { ServiceData } from "./types";
import OptimizedImage from "../OptimizedImage";

interface ServiceCardProps {
  service: ServiceData;
}

const ServiceCard = ({ service }: ServiceCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer h-[600px]"
      onClick={() => navigate(service.path)}
    >
      <div className="flex flex-col h-full">
        {/* Top carousel section */}
        <div className="h-[400px]">
          {service.images && service.images.length > 0 && (
            <FadingCarousel images={service.images} />
          )}
        </div>

        {/* Bottom images section */}
        {service.images && service.images.length > 0 && (
          <div className="grid grid-cols-2 gap-2 p-2">
            {service.images.slice(0, 2).map((img, index) => (
              <div key={index} className="h-[100px]">
                <OptimizedImage
                  src={img}
                  alt={`${service.title} treatment ${index + 1}`}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            ))}
          </div>
        )}

        {/* Overlay content */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent flex flex-col justify-end p-6">
          <h3 className="text-2xl font-serif text-white mb-2">{service.title}</h3>
          <p className="text-white/90 mb-4">{service.description}</p>
          <ul className="space-y-1">
            {service.treatments.map((treatment) => (
              <li key={treatment} className="text-white/80 text-sm">
                • {treatment}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;